import { atom } from "recoil";
import { FilterDef } from "../../../constants/FinanceModels";

export const STATE_FUEL_TABLE_UPDATING = atom<boolean>({
    key: "fuel-state-table-updating",
    default: false
});
export const STATE_FUEL_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'fuel-state-active-filters',
    default: []
});
export const STATE_REGISTRY_FUEL_TABLE_UPDATING = atom<boolean>({
    key: "registry-fuel-state-table-updating",
    default: false
});
export const STATE_REGISTRY_FUEL_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'registry-fuel-state-active-filters',
    default: []
});

